if($('.type-detail').length){
    $(document).ready(updatePriceSaveStateOnLoad);
    $(document).ready(function () {
        initQuantityDiscountInfo($('.p-info-wrapper'));
    });
    const $availability = $('.availability-value');
    var availabilityText = $availability.text();

    var shouldActivate = stavyNaZony.some(function(state) {
        return availabilityText.includes(state);
    });

    if (shouldActivate) {
        const $infoWrapper = $('.p-info-wrapper');

        if (!$infoWrapper.find('.infoTree').length) {
            $infoWrapper.append($('footer#footer .infoTree'));
        }

        if (!$infoWrapper.find('.infoTreeDelivery').length) {
            $infoWrapper.append($('footer#footer .infoTreeDelivery'));
        }
    }
    else{

    }
   


    $('li[data-testid="tabDescription"] a').text(translation('popisProduktu'))
    if($('.p-final-price-wrapper .price-save').length){
        var $def = $('.p-final-price-wrapper .price-save');
        var html = $def.html();
        html = html.replace(/až/gi, '<span class="small">až</span>');
        $def.html(html);
    }
    $('.extended-description').wrapInner('<div class="extendedParams"></div>');
   $(function () {
    const $extended = $('.extended-description');
    const $rows = $extended.find('.detail-parameters tr');

    let propertiesText = null;
    let guideText = null;
    let guideUrl = null;
    const collectedRows = {};
    $rows.each(function () {
        const $row = $(this);
        const label = $row.find('th').text().trim();
        const labelKey = $row.find('th .row-header-label').clone().children().remove().end().text().replace(':', '').trim();
        const hasLink = $(this).find('td a').length > 0;
        const isCategory = labelKey === 'Kategorie';

        // NÁVOD NA PĚSTOVÁNÍ
        if (label.startsWith(translation('navodnapestovani'))) {
            const raw = $row.find('td').text().trim();

            // očekávaný formát: Text - /url
            const parts = raw.split(' - ');
            if (parts.length === 2) {
                guideText = parts[0].trim();
                guideUrl = parts[1].trim();
            }

            $row.hide();
        }
   
        if (hasLink && !isCategory) {
            $row.hide();
            return;
        }

        if (visibleParams.includes(labelKey)) {
            if (!collectedRows[labelKey]) {
                collectedRows[labelKey] = $row.detach();
            }
            return;
        }
       
        
        $row.hide();

    });
    visibleParams.forEach(labelKey => {
    if (collectedRows[labelKey]) {
        $('.detail-parameters').append(collectedRows[labelKey].show());
    }
    });
    if (propertiesText) {
        const properties = propertiesText.split(',').map(p => p.trim());
        const $wrapper = $('<div class="topParameters"></div>');
        const $ul = $('<ul class="parameters"></ul>');
        properties.forEach(prop => {
            const slug = slugify(prop);
            let text = prop;

            if (prop.toLowerCase().startsWith('výška')) {
                text = prop.replace(/výška\s*/i, '');
            }
            if (prop.toLowerCase().startsWith('šířka')) {
                text = prop.replace(/šířka\s*/i, '');
            }
            const $li = $(`
                <li class="property property-${slug}">
                    <span class="property-icon">
                        <img src="/user/documents/upload/detail/top-vlastnosti/${slug}.svg" alt="${prop}">
                    </span>
                    <span class="property-text">${text}</span>
                </li>
            `);

            $ul.append($li);
        });

        $wrapper.append($ul);
        $extended.prepend($wrapper);
    }
    if (guideText && guideUrl) {
        const $guideBtn = $(`
            <div class="plantingGuide">
                <a href="${guideUrl}" class="plantingGuideBtn btn btn-primary">
                    ${guideText}
                </a>
            </div>
        `);
        $extended.append($guideBtn);
    }
});



    var flags = $('.product-top>.col-xs-12:not(.col-lg-6) .flags').html() || '';
    var topTitle = $('.p-detail>.p-detail-inner>.p-detail-inner-header h1').html();
    var topCode = $('.p-detail>.p-detail-inner>.p-detail-inner-header .p-code').html();
    var customInfoWrapper = `
        <div class="customFlags flags-default flags">${flags}</div>
        <div class="h1">${topTitle}</div>
        <div class="customCode">${topCode}</div>
        <div class="customCart"></div>
    `;
    $('.p-image').append(`<div class="customFlags flags-default flags">${flags}</div>`)
    $('.p-info-wrapper').append(customInfoWrapper);
    $('.customCart').append($('.p-info-wrapper .p-final-price-wrapper'), $('.p-info-wrapper .add-to-cart'));
    if($('.p-info-wrapper .detail-parameters .sold-out').length){
        $('.customCart').append('<div class="soldOut">'+$('.p-info-wrapper .detail-parameters .sold-out').text()+'</div>')
    }
    if ($('#simple-variants').length) {
    createStockInfoBlock();
    renderChooseVariants();

    const variants = getVariantsData();
    const activeIndex = $('.chooseVariantItem.active').data('index');

    const activeVariant = variants.find(v =>
        String(v.index) === String(activeIndex)
    );

    if (activeVariant) {
        updateStockInfo(activeVariant.code);
    }
}
    if($('.shipping-options').length){
        $('.customStockLine .right .delivery-link').append($('.shipping-options'));
    };
    if ($('.p-thumbnails-wrapper .p-thumbnails-inner').length) {
        $('.p-image-wrapper').addClass('haveThumbnails');
        $('.p-image-wrapper').append('<span class="arrow-prev"></span><span class="arrow-next"></span>');
        $('body').on('click', '.arrow-prev, .arrow-next', function () {
            var thumbnails = $('.p-thumbnails-inner').find('a.p-thumbnail, a.show360image');
            var highlightedThumbnail = $('.p-thumbnails-inner').find('a.highlighted');
            var isNext = $(this).hasClass('arrow-next');
            var totalThumbnails = thumbnails.length;
            var currentIndex = thumbnails.index(highlightedThumbnail);
            thumbnails.removeClass('highlighted');
            if (highlightedThumbnail.length === 0) {
                highlightedThumbnail = isNext ? thumbnails.first() : thumbnails.last();
            } else {
                currentIndex = isNext ? (currentIndex + 1) % totalThumbnails : (currentIndex - 1 + totalThumbnails) % totalThumbnails;
                highlightedThumbnail = thumbnails.eq(currentIndex);
            }
            highlightedThumbnail.addClass('highlighted');
            setTimeout(function () {
                updateMainImage(highlightedThumbnail);
            }, 10);
        });

       $(function () {
            const maxVisible = 3;
            const $thumbs = $('.p-thumbnail img');
            const total = $thumbs.length;
            $thumbs.each(function () {
                const $img = $(this);
                const src = $img.attr('data-src');
                if (src && src.includes('/related/')) {
                    const origSrc = src.replace('/related/', '/orig/');
                    $img.attr('data-src', origSrc);
                }
            });
            $thumbs.slice(maxVisible+1).closest('a.p-thumbnail').hide();
            if (total > maxVisible) {
                const hiddenCount = total - maxVisible;
                const label = sklonujFotky(hiddenCount);
                const $btn = $(`
                    <span class="morePhotosBtn">
                        + ${hiddenCount} ${label}
                    </span>
                `);
                $thumbs.eq(maxVisible).closest('a.p-thumbnail').addClass('lastImage').html($btn);
                $btn.on('click', function (e) {
                    e.preventDefault();
                    $thumbs.eq(maxVisible).trigger('click');
                });
            }
        });


    }






    updatePriceSaveState();
    $(document).ready(initThumbnailLayout);


    

}

$('body').on('click', '.p-thumbnail', function (e) {
    e.preventDefault();

    const $thumb = $(this);
    const $cbox = $thumb.next('.cbox-gal.cboxElement');

    // zvýraznění
    $('.p-thumbnail').removeClass('highlighted');
    $thumb.addClass('highlighted');

    // update hlavního obrázku
    updateMainImage($thumb);

    // 🔥 otevři Colorbox
    if ($cbox.length) {
        $cbox.trigger('click');
    }
});

function initThumbnailLayout() {
    const $thumbs = $('.p-thumbnails-inner a.p-thumbnail');

    if (!$thumbs.length) return;

    $thumbs.each(function (i) {
        if (i === 0) {
            $(this).addClass('thumb-large');
        } else if (i === 1 || i === 2) {
            $(this).addClass('thumb-small');
        } else {
            $(this).addClass('thumb-small');
        }
    });
}


function updateMainImage(highlightedThumbnail) {
    var findHighlighted = highlightedThumbnail.attr('href');
    var findHighlightedAlt = highlightedThumbnail.find('img').attr('alt');
    $('.p-image a.p-main-image').attr('href', findHighlighted).find('img').attr({'src': findHighlighted, 'alt': findHighlightedAlt});
}

function getVariantsData() {

    const variants = [];

    // ======================================
    // 🔹 SELECT VARIANTY (dropdown)
    // ======================================

    const $select = $('#simple-variants-select');

if ($select.find('option').length>1) {

    $select.find('option').each(function () {

        const $opt = $(this);
        const index = $opt.data('index');
        
        if (!index || index === 0) return;

        const text = $opt.text().trim();
        const variantCode = $('.availability-value span.choose-variant.' + index).find('.product-stock-amount').data('variant-code');
       
        const priceMatch = text.match(/\((.*?)\)/);
        const priceFinal = priceMatch ? getNumber(priceMatch[1]) : null;

        // ✔ dostupnost podle indexu (stejně jako radio varianty)
        const $availability = getByIndexOrFallback(
        '.availability-value > span.choose-variant.' + index + ' .availability-label',
        '.availability-value .availability-label'
        );

        const stockText = $availability.text().trim();
        const stockColor = $availability.attr('style');
    
        const name = text
            .split('-')[0]
            .replace(/\(.*?\)/, '')
            .trim();

        variants.push({
            index,
            //code: $opt.data('codeid'),
            code: variantCode,
            price: priceFinal,
            unit: '',

            image: $('.p-image img').first().attr('src'),
            name,
            input: $opt,

            stock: stockText,
            stockColor,

            priceFinal,
            priceStandard: null,
            priceSavePercent: null,
            isSale: false
        });

    });

    return variants;
}


    // ======================================
    // 🔹 PŮVODNÍ LOGIKA
    // ======================================

    const hasMultipleVariants = $('#simple-variants label.advanced-parameter').length > 1;

    // ======================================
    // 🔹 JEDNA VARIANTA
    // ======================================
    if (!hasMultipleVariants) {

        const $priceFinalHolder = $('.p-final-price-wrapper .price-final-holder').first();
        const $priceStandard = $('.p-final-price-wrapper .price-standard').first();
        const $priceSave = $('.p-final-price-wrapper .price-save').first();
        const $availability = $('.availability-value .availability-label');

        const priceFinalText = $priceFinalHolder
            .clone()
            .children()
            .remove()
            .end()
            .text()
            .trim();

        const priceFinal = getNumber(priceFinalText);

        const unit = $priceFinalHolder.find('.pr-list-unit').text().trim();

        const priceStandardText = $priceStandard.text().trim();
        const priceStandard = priceStandardText
            ? getNumber(priceStandardText)
            : null;

        const priceSaveText = $priceSave.text().trim();
        const priceSavePercent = priceSaveText.includes('%')
            ? parseInt(priceSaveText.replace(/[^\d]/g, ''), 10)
            : null;

        const stockText = $availability.clone().children().remove().end().text().trim();
        const stockColor = $availability.attr('style');

        const rawCode =
            $('.p-code .choose-variant').first().text().trim() ||
            $('.p-code').text().trim();

        const code = rawCode.replace(/[^\d]/g, '');

        const image =
            $('#simple-variants input[type="radio"]').data('detail_small') ||
            $('#simple-variants input[type="radio"]').data('big') ||
            $('.p-image img').first().attr('src');

        const name =
            $('#simple-variants select option').text().split('-')[0].trim() ||
            $('.p-detail-inner-header h1').text().trim();

        variants.push({
            index: 1,
            code,
            price: priceFinal,
            unit,
            image,
            name,
            input: null,

            stock: stockText,
            stockColor,

            priceFinal,
            priceStandard,
            priceSavePercent,
            isSale: priceStandard !== null && priceFinal < priceStandard
        });

        return variants;
    }

    // ======================================
    // 🔹 VÍCE VARIANT (TVŮJ PŮVODNÍ KÓD)
    // ======================================

    $('#simple-variants label.advanced-parameter').each(function () {

        const $label = $(this);
        const $input = $label.find('input[type="radio"]');
        const index = $input.data('index');

        const $priceFinalHolder = getByIndexOrFallback(
            '.price-final-holder.choose-variant.' + index,
            '.price-final-holder'
        );

        const $priceStandardVariant = getByIndexOrFallback(
            '.price-standard .choose-variant.' + index + ':not(.default-variant)',
            '.price-standard .price-standard-holder'
        );

        const $priceSaveVariant = getByIndexOrFallback(
            '.price-save .choose-variant.' + index + ':not(.default-variant)',
            '.price-save'
        );

        const $availability = getByIndexOrFallback(
            '.p-info-wrapper .availability-value > span.' + index + ' .availability-label',
            '.p-info-wrapper .availability-label'
        );

        const $codeEl = getByIndexOrFallback(
            '.p-code .choose-variant.' + index,
            '.p-code'
        );

        const code = $codeEl
            .text()
            .replace('Kód:', '')
            .replace(/\s+/g, '')
            .trim();

        const priceFinalText = $priceFinalHolder
            .clone()
            .children()
            .remove()
            .end()
            .text()
            .trim();

        const priceFinal = getNumber(priceFinalText);

        const unit = $priceFinalHolder.find('.pr-list-unit').text().trim();

        const priceStandardText = $priceStandardVariant.text().trim();
        const priceStandard = priceStandardText && priceStandardText !== '–'
            ? getNumber(priceStandardText)
            : null;

        const priceSaveText = $priceSaveVariant.text().trim();
        const priceSavePercent = priceSaveText && priceSaveText.includes('%')
            ? parseInt(priceSaveText.replace(/[^\d]/g, ''), 10)
            : null;

        const image = $input.data('detail_small') || $input.data('big');
        const name = $label.find('.advanced-parameter-inner').attr('title');

        variants.push({
            index,
            code,
            price: priceFinal,
            unit,
            image,
            name,
            input: $input,

            stock: $availability.clone().children().remove().end().text().trim(),
            stockColor: $availability.attr('style'),

            priceFinal,
            priceStandard,
            priceSavePercent,
            isSale: priceStandard !== null && priceFinal < priceStandard
        });

    });

    return variants;
}



/*
function getStockFromDataLayer(code) {
    const dl = window.dataLayer?.find(d => d.shoptet?.product)?.shoptet;
    if (!dl || !dl.product || !Array.isArray(dl.product.codes)) return null;

    let variant = null;

    // jedna varianta → vezmi ji
    if (dl.product.codes.length === 1) {
        variant = dl.product.codes[0];
    } else if (code != null) {
        const normalizedCode = String(code).trim();
        variant = dl.product.codes.find(v => String(v.code) === normalizedCode);
    }

    if (!variant) return null;

    const stockMap = {};
    (variant.stocks || []).forEach(s => {
        stockMap[String(s.id)] = String(s.quantity).trim();
    });

    return {
        total: String(variant.quantity).trim(),
        eshop: stockMap['5'] ?? '0',
        store: stockMap['1'] ?? '0'
    };
}*/

function getStockFromDataLayer(code) {

    const dl = window.dataLayer?.find(d => d.shoptet?.product)?.shoptet;
    if (!dl || !dl.product || !Array.isArray(dl.product.codes)) return null;

    let variant = null;

    if (dl.product.codes.length === 1) {
        variant = dl.product.codes[0];
    } else if (code != null) {
        const normalizedCode = String(code).trim();
        variant = dl.product.codes.find(v => String(v.code) === normalizedCode);
    }

    if (!variant) return null;

    // map názvů skladů
    const stockTitles = {};
    (dl.stocks || []).forEach(s => {
        stockTitles[String(s.id)] = s.title;
    });

    const resultStocks = [];
    let totalQty = 0;

    (variant.stocks || []).forEach(s => {
            let rawQty = String(s.quantity).trim();

    // odstraní znak > a mezery
    rawQty = rawQty.replace(/[^\d]/g, '');

    const qty = parseInt(rawQty, 10) || 0;
        if (qty <= 0) return;

        totalQty += qty;

        resultStocks.push({
            id: s.id,
            title: stockTitles[String(s.id)] || `Sklad ${s.id}`,
            quantity: qty
        });
    });
 console.log(code, dl.product.codes);
    return {
        total: totalQty,
        inStock: totalQty > 0,
        stocks: resultStocks
    };
   
}




function renderChooseVariants() {
    const variants = getVariantsData();

    const availableVariants = variants.filter(v => !isNotInStock(v));
    const unavailableVariants = variants.filter(isNotInStock);
    //const unavailableVariants = variants.filter(v => !isInStock(v));

    const variantLabelsCount = $('#simple-variants label.advanced-parameter').length;
    const isSingleVariant = variantLabelsCount === 1;

    // 👉 skutečně vybraná varianta ze Shoptetu
    const checkedIndex = $('#simple-variants input[type="radio"]:checked').data('index');

    const $wrap = $(`
        <div class="chooseVariant">
            <div class="h3">${translation('variantTitle')}:</div>
            <div class="inner"></div>
        </div>
    `);

    const $inner = $wrap.find('.inner');

    function renderVariant(v) {
        const isActive =
            isSingleVariant ||
            (checkedIndex && String(v.index) === String(checkedIndex));

        let priceHtml = `
            <span class="priceFinal">
                ${Number(v.priceFinal).ShoptetFormatAsCurrency()} ${v.unit}
            </span>
        `;

        if (v.isSale && v.priceStandard) {
            priceHtml = `
                <span class="priceStandard isSaleBox">
                    ${Number(v.priceStandard).ShoptetFormatAsCurrency()}
                </span>
                <span class="priceFinal">
                    ${Number(v.priceFinal).ShoptetFormatAsCurrency()} ${v.unit}
                </span>
            `;
        }

        const saleBadge = v.isSale && v.priceSavePercent
            ? `<span class="saleBadge">-${v.priceSavePercent}%</span>`
            : '';
        
        return $(`
            <div class="chooseVariantItem ${isActive ? 'active' : ''}" data-index="${v.index}">
                <div class="img">
                    ${saleBadge}
                    <img src="${v.image}" alt="" loading="eager">
                </div>
                <div class="info">
                    <div class="name">${v.name}</div>
                    <div class="bottomMargin">
                        <div class="stock">
                            <span style="${v.stockColor}">${v.stock}</span>
                        </div>
                        <div class="price">
                            ${priceHtml}
                        </div>
                    </div>
                </div>
            </div>
        `);
    }

    // =========================
    // 🔹 RENDER
    // =========================

    // vždy nejdřív dostupné
    availableVariants.forEach(v => {
        $inner.append(renderVariant(v));
    });

    // toggle na nedostupné
    unavailableVariants.forEach(v => { 
        $inner.append(renderVariant(v)); 
    });

    $('.p-info-wrapper').append($wrap);
    
    let $activeItem = $('.chooseVariantItem.active');

    // pokud jsme našli lepší dostupnou variantu → přepni ji
    

    // teď už vždy bereme správnou variantu
    if ($activeItem.length) {
        const index = $activeItem.data('index');
        const variant = variants.find(v => String(v.index) === String(index));
        
if (variant) {
    updateStockInfo(variant.code);
}
    }
}


$(document).on('change', '#simple-variants-select', function () {

    const code = $(this).find('option:selected').data('codeid');

    if (!code) return;

    const variants = getVariantsData();
    const variant = variants.find(v => String(v.code) === String(code));

    if (!variant) return;

    $('.chooseVariantItem').removeClass('active');
    $('.chooseVariantItem[data-index="' + variant.index + '"]').addClass('active');
   
    updateStockInfo(variant.code);
});


$(document).on('click', '.chooseVariantItem', function () {

    const index = $(this).data('index');
    const variant = getVariantsData().find(v =>
        String(v.index) === String(index)
    );

    if (!variant) return;

    // ======================================
    // RADIO VARIANTY
    // ======================================

    const $radio = $('#simple-variants input[data-index="' + index + '"]');

    if ($radio.length) {
        $radio.trigger('click');
    }

    // ======================================
    // SELECT VARIANTY
    // ======================================

    const $select = $('#simple-variants-select');

    if ($select.length && variant.input) {
        $select.val(variant.input.val()).trigger('change');
    }

    // ======================================

    $('.chooseVariantItem').removeClass('active');
    $(this).addClass('active');

    updateStockInfo(variant.code);

    setTimeout(updatePriceSaveState, 0);
});

function getAllStockTitles() {
    const product = dataLayer.find(item => item.shoptet?.product);
    if (!product || !product.shoptet.product.stocks) return [];

    return product.shoptet.product.stocks.map(s => s.title);
}

function createStockInfoBlock() {

    if ($('.customStockLine').length) return;

    let rowsHtml = '';

    // najdeme shoptet objekt v dataLayer
    const dlItem = dataLayer.find(item => item.shoptet && item.shoptet.stocks);
  
    if (dlItem && dlItem.shoptet.stocks.length) {

        dlItem.shoptet.stocks.forEach(s => {

            if (s.visibleOnEshop) {
               
                rowsHtml += `
                    <div class="lineRow" data-stock-id="${s.id}">
                        <strong>${s.title}:</strong>
                        <span>-</span>
                    </div>
                `;

            }

        });
    }

    // fallback (kdyby něco selhalo)
    if (!rowsHtml) {
        rowsHtml = `
            <div class="lineRow">
                <strong>${translation('stock')}:</strong>
                <span>-</span>
            </div>
        `;
    }

    const html = `
        <div class="customStockLine">
            <div class="left">
                <div class="inner">
                    ${rowsHtml}
                </div>
            </div>
            <div class="right">
                <span class="delivery-link"></span>
                <a href="${$('.link-icons .watchdog').attr('href')}" 
                   class="link-icon watchdog" 
                   style="display:none" 
                   rel="nofollow" 
                   title="${translation('hlidat')}">
                   ${translation('hlidat')}
                </a>
            </div>
        </div>
    `;

    $('.p-info-wrapper').append(html);
}




/*
function updateStockInfo(code) {

    const stock = getStockFromDataLayer(code);
    if (!stock) return;

    const $customStock = $('.customStockLine');
    const $inner = $customStock.find('.inner');

    const eshopQty = String(stock.eshop).trim();
    const storeQty = String(stock.store).trim();

    const isInStock = !(eshopQty === '0' && storeQty === '0');

    // ===============================
    // ❌ NENÍ SKLADEM (DL)
    // ===============================

    const availability = getActiveVariantStockText();
    if (!isInStock) {

    

    $customStock.addClass('disabledStock');
    $('.social-buttons-wrapper').hide();

    $inner.html(`
        <div class="availabilityText" style="color:#cb0000">
            ${availability.text}
        </div>
    `);

    $('.delivery-link').hide();
    $('.watchdog').show();
    return;
}


    // ===============================
    // ✅ JE SKLADEM
    // ===============================
    $customStock.removeClass('disabledStock');
    $('.social-buttons-wrapper').show();
    if (!$inner.find('.js-stock-eshop').length) {
       
        $inner.html(`
            <div class="lineRow">
                <strong>${translation('stockEshop')}:</strong>
                <span class="js-stock-eshop" style="color:#59822E"></span>
            </div>
            <div class="lineRow">
                <strong>${translation('stockProdejna')}:</strong>
                <span class="js-stock-store" style="color:#59822E"></span>
            </div>
        `);
    }

    $('.js-stock-eshop').text(eshopQty+' ks').attr('style', 'color:#59822E');
    $('.js-stock-store').text(storeQty+' ks').attr('style', 'color:#59822E');

    $('.delivery-link').show();
    $('.watchdog').hide();
}*/

function updateStockInfo(code) {

const stock = getStockFromDataLayer(code);
    console.log(stock)
    const $customStock = $('.customStockLine');
    const $inner = $customStock.find('.inner');

    const availability = getActiveVariantStockText();

    // ===============================
    // ❌ NENÍ SKLADEM (stock null nebo false)
    // ===============================
    if (!stock || !stock.inStock) {

        $customStock.addClass('disabledStock');
        $('.social-buttons-wrapper').hide();

        $inner.html(`
            <div class="availabilityText" style="color:#cb0000">
                ${availability.text}
            </div>
        `);

        $('.delivery-link').hide();
        $('.watchdog').show();
        return;
    }

    // ===============================
    // ✅ JE SKLADEM
    // ===============================
    $customStock.removeClass('disabledStock');
    $('.social-buttons-wrapper').show();

    let rowsHtml = '';

    stock.stocks.forEach(s => {
        
        rowsHtml += `
            <div class="lineRow" data-stock-id="${s.id}">
                <strong>${s.title}:</strong>
                <span style="color:#59822E">${s.quantity} ks</span>
            </div>
        `;
    });

    // fallback – kdyby byl skladem, ale žádný sklad neměl qty (edge-case)
    if (!rowsHtml) {
        rowsHtml = `
            <div class="availabilityText" style="color:#59822E">
                ${availability.text}
            </div>
        `;
    }

    $inner.html(rowsHtml);

    $('.delivery-link').show();
    $('.watchdog').hide();
}



function getNumber(value) {
    return parseFloat(
        value
            .replace(/\s/g, '')     // odstraní mezery
            .replace(',', '.')      // čárku na tečku
            .replace(/[^\d.]/g, '') // vše kromě čísla a tečky pryč
    );
}

function isInStock(variant) {
    return variant.stock?.toLowerCase().includes(translation('helperSkladem'));
}

function isNotInStock(variant) {
    const stockText = normalizeStockText(variant.stock);

    return NOT_IN_STOCK_STATES.some(state =>
        stockText.includes(normalizeStockText(state))
    );
}


function updatePriceSaveState() {
    const $wrapper = $('.p-final-price-wrapper');

    // ===== JEDNA VARIANTA =====
    if (!hasMultipleVariants()) {
        const text = $wrapper.find('.price-save').text().trim();

        const hasDiscount =
            text !== '' &&
            text !== '-' &&
            text.includes('%');

        $wrapper.toggleClass('hasDiscount', hasDiscount);
        return;
    }

    // ===== VÍCE VARIANT =====
    const $activeFinal = $wrapper.find(
        '.price-final-holder.choose-variant:not(.no-display):not(.default-variant)'
    ).first();

    if (!$activeFinal.length) {
        $wrapper.removeClass('hasDiscount');
        return;
    }

    const index = $activeFinal
        .attr('class')
        .split(' ')
        .find(c => /^\d+$/.test(c));

    if (!index) {
        $wrapper.removeClass('hasDiscount');
        return;
    }

    const $priceSave = $wrapper.find(
        `.price-save .choose-variant.${index}`
    );

    const hasDiscount =
        $priceSave.length &&
        !$priceSave.hasClass('empty') &&
        !$priceSave.hasClass('no-display') &&
        $priceSave.text().trim() !== '-' &&
        $priceSave.text().trim() !== '';

    $wrapper.toggleClass('hasDiscount', hasDiscount);
}


function updatePriceSaveStateOnLoad() {
    const $wrapper = $('.p-final-price-wrapper');

    // ===== JEDNA (nebo žádná) VARIANTA =====
    if (!hasMultipleVariants()) {
        const text = $wrapper.find('.price-save').text().trim();

        const hasDiscount =
            text !== '' &&
            text !== '-' &&
            text.includes('%');

        $wrapper.toggleClass('hasDiscount', hasDiscount);
        return;
    }

    // ===== VÍCE VARIANT → DEFAULT =====
    const $defaultSave = $wrapper.find(
        '.price-save .choose-variant.default-variant'
    );

    if (!$defaultSave.length) {
        $wrapper.removeClass('hasDiscount');
        return;
    }

    const hasDiscount =
        $defaultSave.text().trim() !== '' &&
        $defaultSave.text().trim() !== '-' &&
        !$defaultSave.hasClass('empty');

    $wrapper.toggleClass('hasDiscount', hasDiscount);
}


function hasMultipleVariants() {
    return $('#simple-variants label.advanced-parameter').length > 1;
}



function getActiveVariantStockText() {
    const $active = $('.chooseVariantItem.active');

    if ($active.length) {
        return {
            text: $active.find('.stock span').text().trim(),
            color: $active.find('.stock span').attr('style') || ''
        };
    }
    else{
        return {
            text: $('.availability-value>span').first().text().trim(),
            color: $('.availability-value>span').first().attr('style')
        }
    }

  
    
}

function sklonujFotky(count) {
    if (count === 1) return translation('dalsifotografie');
    if (count >= 2 && count <= 4) return translation('dalsifotografie');
    return translation('dalsichFotografii');
}

function slugify(str) {
    return str
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

$('html').on('click', 'a.shipping-options', function (e) {
    e.preventDefault();
    const waitForPopup = setInterval(function () {
        const $popup = $('.shipping-options-popup');
        if (!$popup.length) return;
        clearInterval(waitForPopup);
        const zoneNames = deliveryZonesConfig.map(z => z.name);
        const minPrice = Math.min.apply(null, deliveryZonesConfig.map(z => z.price));
        let foundAnyZone = false;
        $popup.find('.shipping-row').each(function () {
            const $row = $(this);
            const name = $row.find('.shipping-billing-name').text().trim();
            if (zoneNames.includes(name)) {
                foundAnyZone = true;
                $row.remove();
            }
            if ($(this).find('.shipping-billing-name').text().includes('Rozdělení objednávky')) {
                
                $row.remove();
            }

        });
        if (foundAnyZone) {
            const formattedPrice = minPrice;
            const mergedRow = `
                <div class="shipping-row shipping-row--merged">
                    <span class="payment-info">
                        <b class="shipping-billing-name">${preprava}</b>
                    </span>
                    <strong class="payment-shipping-price">${translation('od')} ${Number(formattedPrice).ShoptetFormatAsCurrency()}</strong>
                </div>
            `;
            $popup.append(mergedRow);
        }

    }, 1);
});


function getByIndexOrFallback(selectorByIndex, selectorFallback) {
    const $byIndex = $(selectorByIndex);
    return $byIndex.length
        ? $byIndex.first()
        : $(selectorFallback).first();
}

function initQuantityDiscountInfo($wrap) {
    
    var $discountWrap = $wrap.find('.quantity-discounts');
    if (!$discountWrap.length) return;

    var $amountInput = $wrap.find("input[name='amount']");
    var $increase = $wrap.find(".increase");
    var $decrease = $wrap.find(".decrease");

    var discounts = [];
    var basePrice = parseFloat($discountWrap.find('.quantity-discounts__table').data('orig-price'));

   $discountWrap.find('.quantity-discounts__item').each(function () {
        var $itemData = $(this);
        var rawText = $itemData.find('.quantity-discounts__title').text();
        var cleanText = rawText
            .replace(/\u00a0/g, ' ')   // &nbsp;
            .replace(/\s+/g, ' ')      // vícenásobné mezery
            .trim();
        var textSplit = cleanText.split('=');
        var name = textSplit[0] ? textSplit[0].trim() : '';
        var sale = '';
        if (textSplit[1]) {
            var match = textSplit[1].match(/(\d+)\s*%/);
            if (match) {
                sale = '-' + match[1] + '%';
            }
        }
        $itemData.find('.quantity-discounts__title').html(
            '<span class="name">' + name + '</span>' +
            (sale ? '<span class="sale">' + sale + '</span>' : '')
        );
        discounts.push({
            amount: parseInt($itemData.data('amount'), 10),
            ratio: parseFloat($itemData.data('price-ratio')),
            price: Math.round(basePrice * parseFloat($itemData.data('price-ratio')))
        });
    });

    discounts.sort((a, b) => a.amount - b.amount);

    var $infoBox = $('<div class="qtyDiscountInfo"></div>');
    $('.p-info-wrapper').append($infoBox);

    function getCurrentTier(qty) {
        var current = discounts[0];
        discounts.forEach(function (d) {
            if (qty >= d.amount) current = d;
        });
        return current;
    }

    function getNextTier(qty) {
        for (var i = 0; i < discounts.length; i++) {
            if (discounts[i].amount > qty) {
                return discounts[i];
            }
        }
        return null;
    }

    function renderInfo(qty) {
        if (qty <= 0) {
            $infoBox.html('');
            return;
        }

        var current = getCurrentTier(qty);
        var next = getNextTier(qty);

        var savedNow = Math.max(0, (basePrice - current.price) * qty);

        var html = `
            ${translation('nyniUsetrite')} <strong>${Number(savedNow).ShoptetFormatAsCurrency()}.</strong>
        `;

        if (next) {
            var diff = next.amount - qty;
            var savePerItem = current.price - next.price;

            html += `
                ${translation('pridejtejeste')} <strong>${diff} ${translation('ks')}</strong> 
                ${translation('usetrite')} <strong class="green">${Number(savePerItem).ShoptetFormatAsCurrency()} / ${translation('ks')}</strong>.
            `;
        } else {
            html += `${translation('nejlepsicena')}`;
        }

        $infoBox.html(html);
    }

    function getQty() {
        return parseInt($amountInput.val(), 10) || 0;
    }

    $increase.on('click', function () {
        renderInfo(getQty() + 1);
    });

    $decrease.on('click', function () {
        renderInfo(Math.max(0, getQty() - 1));
    });

    $amountInput.on('input change', function () {
        renderInfo(getQty());
    });

    renderInfo(getQty());

    $discountWrap.on('click', '.quantity-discounts__item', function () {
        var qty = parseInt($(this).data('amount'), 10);
        if (!qty || isNaN(qty)) return;
        $amountInput.val(qty).trigger('change');
        renderInfo(qty);
    });

}

function normalizeStockText(text) {
    return (text || '')
        .toString()
        .toLowerCase()
        .trim();
}
